export const hpsAccionesRoles = {
  sharedActions: {
    items: ['Chief', 'HPs'],
    workOrder: ['Chief', 'HPs'],
    management: ['Chief', 'HPs'],
    workProgress: ['Chief', 'HPs'],
    validation: ['Chief', 'HPs'],
    efficiency: [
      'Chief',
      'HpsChief',
      'StandardsAdmin',
      'HpsSupervisor',
      'Admin',
      'HpsAdmin',
      'HpsStandardsAdmin',
      'HpsEngineer',
    ],
    packingBox: [
      'Chief',
      'Admin',
      'LabelOperator',
      'HpsSupervisor',
      'HpsLabelOperator',
    ],
  },

  routerActions: {
    // No hay rutas exclusivas del router
  },

  sideNavActions: {
    reportsPbiHps: ['Chief', 'HPs'],
    root: ['Chief', 'HPs'],
  },
};
